export const ROUTES = {
  Home: '/',
  NotFound: '*',
  Dashboard: '/dashboard',
  Customers: '/clientes',
  Employees: '/funcionarios',
  Orders: '/vendas',
  Products: '/produtos',
  Suppliers: '/fornecedores',
  Purchases: '/entradas',
  Users: '/utilizadores',
  Preferences: '/preferencias',
  Profile: '/conta',
  StoreFront: '/loja',
  CustomerOrders: '/pedidos',
};

export const AUTH_ROUTES = {
  AuthSignIn: '/entrar',
  AuthSignUp: '/criar-conta',
};
